import { t } from 'i18next';
import { ApiError } from './ApiError';

export function isServerError(error: Error): error is ServerError {
  return error.constructor === ServerError;
}

export class ServerError extends ApiError {
  static async create(response: Response) {
    const errorResponse = await this.extractError(response);

    const newError = new ServerError(response, errorResponse);

    newError.message =
      (errorResponse.i18n && t(errorResponse.i18n.key, errorResponse.i18n.parameters)) ||
      errorResponse.message ||
      t('Error.Category.ServerError.message');

    return newError;
  }
}
